import breakpoints from '../../../../theme/breakpoints'
import theme from '../../../../theme/news12'

import css from 'styled-jsx/css'

export default css.div`
  @media only screen and (max-width: ${breakpoints.md}px) {
    .card {
      margin-bottom: 10px;
      padding: 15px 24px;
      background-color: ${theme.colors.white};
      border: 1px solid ${theme.colors.lightGray3};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    }
    
    .card-content {
      display: flex;
      flex-direction: column;
    }
    
    .top {
      order: -1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 11px;
    }
    
    .card-title {
      margin: 0;
      margin-top: 10px;
      font-size: 18px;
    }
    
    .meatball-icon {
      margin: 0;
      padding: 0;
    }
    
    .play-icon {
      margin-bottom: 2px;
    }  
  }
  
    @media only screen and (max-width: ${breakpoints.sm}px) {
    .card {
      padding: 16px;
    }
    
    .timestamp {
      font-size: 13px;
    }
  }
`
